import * as actionTypes from './actionTypes';

export const modalShow = ( name  ) => {
    return {
        type: actionTypes.MODAL_SHOW,
        name: name
    };
};

export const modalHide = () => {
    return {
        type: actionTypes.MODAL_HIDE
    };
};
export const modalNext = () => {
    return {
        type: actionTypes.MODAL_NEXT
    };
};